__turbopack_context__.v({
  "back": "back-link-module-scss-module___5JyuG__back",
  "icon": "back-link-module-scss-module___5JyuG__icon",
});
